import { PollingStatus, StatusProvider } from '@/tax/models';

export class ScenarioRun {
    id = -1;
    type = ScenarioRunType.Save;
    scenarioId = -1;
    loadTo = {};
    status = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    targetWorkflowId?: number;
    targetPeriodId?: number;
    targetCompanyId?: number;
    reconciliationIds?: number[];

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.type = data.type ?? ScenarioRunType.Save;
        this.scenarioId = data.scenario_id ?? -1;
        this.loadTo = data.load_to ?? {};
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            type: this.type,
            company_id: this.targetCompanyId,
            period_id: this.targetPeriodId,
            workflow_id: this.targetWorkflowId,
            reconciliation_ids: this.reconciliationIds,
        };
    }
}

export enum ScenarioRunType {
    Save = 'SAVE',
    Load = 'LOAD',
}

export function getLocalizedScenarioRunTypes(): Record<ScenarioRunType, string> {
    return {
        SAVE: $localize`:@@save:Opslaan`,
        LOAD: $localize`:@@load:Inladen`,
    };
}
